import { useAuthStore } from 'stores/useAuthStore'
import { APIResponse, APIError } from 'types/api'

/**
 * 전역 에러 처리 인터셉터
 * - 401: 로그아웃 + redirect
 * - 403: 권한 없음
 * - 나머지는 호출 쪽에서 처리
 */
export const intercept = async <T extends APIResponse>(
  res: Response | null | undefined
): Promise<T> => {
  if (!res) {
    throw {
      isSuccess: false,
      code: -1,
      message: 'No response received',
    } as APIError<T>
  }

  let data: T
  try {
    data = await res.json()
  } catch {
    throw {
      isSuccess: false,
      code: -1,
      message: 'Failed to parse response',
    } as APIError<T>
  }

  // 401 처리: 로그아웃 + redirect
  if (data.code === 401) {
    useAuthStore.getState().logout()
    window.location.href = '/#/error/401'
    throw data
  }

  // 403 처리: 권한 없음
  if (data.code === 403) {
    throw data
  }

  // 나머지는 호출 쪽에서 처리
  return data
}
